import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ForecastState {
  subchartArray: any[];
}

const initialState: ForecastState = {
  subchartArray: []
};

const subChartSlice = createSlice({
  name: 'subChart',
  initialState,
  reducers: {
    setSubChartDetails(state, action: PayloadAction<any>) {
      const existingIndex = state.subchartArray.findIndex(
        (item: { id: any; }) => item.id === action.payload.id
      );

      if (existingIndex !== -1) {
        state.subchartArray[existingIndex] = action.payload;
      } else {
        state.subchartArray.push(action.payload);
      }
    },
    resetSubChartDetails(state) {
      state.subchartArray = [];
    }
  }
});

export const { setSubChartDetails, resetSubChartDetails } = subChartSlice.actions;
export default subChartSlice.reducer;